import React from "react";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";

const SeriesPageMainTabButtonsComponent = ({
  activeTab,
  selectedButton,
  setSelectedButton,
  handleButtonClick,
  handleFetchKlipitItems,
  handleFetchSimilarItems,
  genretSlug,
  showHideSamanlaisiaOhjelmia,
  currentPath,
  data
}) => {
  const shouldShowSimilarButton =
    genretSlug &&
    showHideSamanlaisiaOhjelmia === "Päällä" &&
    !currentPath.startsWith("/uusimmat") &&
    !currentPath.startsWith("/lammas/uusimmat") &&
    !currentPath.startsWith("/lammas/suosittua-nyt") &&
    !currentPath.startsWith("/suosittua-nyt");

  return (
    <div styleName="top-button-wrapper">
      {/* Jaksot */}
      <div styleName={`wrapper-active ${activeTab === "jaksot" ? "active" : ""}`}>
        <button
          styleName={
            activeTab === "jaksot" ||
            (activeTab !== "tarkemmat" &&
            activeTab !== "klipit" &&
            activeTab !== "samanlaisia")
              ? "selected"
              : ""
          }
          onClick={() => {
            setSelectedButton(selectedButton);
            handleButtonClick("jaksot");
          }}
        >
          Jaksot
        </button>
      </div>

      {/* Tarkemmat */}
      <div styleName={`wrapper-active ${activeTab === "tarkemmat" ? "active" : ""}`}>
        <button
          styleName={activeTab === "tarkemmat" ? "selected" : ""}
          onClick={() => {
            handleButtonClick("tarkemmat");
          }}
        >
          Tarkemmat tiedot
        </button>
      </div>

      {/* Klipit */}
      <div styleName={`wrapper-active ${activeTab === "klipit" ? "active" : ""}`}>
        <button
          styleName={activeTab === "klipit" ? "selected" : ""}
          onClick={() => handleFetchKlipitItems("klipit", data?.subSections ?? [])}
        >
          Klipit
        </button>
      </div>

      {/* Samanlaisia ohjelmia */}
      {shouldShowSimilarButton && (
        <div styleName={`wrapper-active ${activeTab === "samanlaisia" ? "active" : ""}`}>
          <button
            styleName={activeTab === "samanlaisia" ? "selected" : ""}
            onClick={() => handleFetchSimilarItems("samanlaisia")}
          >
            Samanlaisia ohjelmia
          </button>
        </div>
      )}
    </div>
  );
};

export default SeriesPageMainTabButtonsComponent;
